import PropTypes from "prop-types";
import ProductRatingContainer from "app/pages/FicheProduit/components/ProductRating/ProductRatingContainer";
import Typography, { TYPOGRAPHY_VARIANTS } from "app/pages/.shared/Typography/Typography";
import "./HotelHeader.scss";
import { memo } from "react";
import ProductSummaryContainer from "app/pages/.shared/ProductSummary/ProductSummaryContainer";
import { PRODUCT_PAGE_CODE_STATUS } from "app/constants";
import TripAdvisorSkeleton from "app/pages/FicheProduit/components/TripAdvisor/TripAdvisorSkeleton/TripAdvisorSkeleton";

const HotelHeader = ({ hotelName, tripAdvisorData = {}, holidayCheckData = {}, status }) => {
	return (
		<div className="hotel-header">
			<Typography
				variant={TYPOGRAPHY_VARIANTS.XL2}
				isBold
				className="hotel-header__name"
				data-testid="hotel-name"
				component="div"
			>
				{hotelName}
			</Typography>

			{status !== PRODUCT_PAGE_CODE_STATUS.SUCCESS ? (
				<TripAdvisorSkeleton />
			) : (
				<ProductRatingContainer
					locationName={hotelName}
					tripAdvisor={tripAdvisorData}
					holidayCheck={{
						...holidayCheckData,
						size: "large",
						isCompact: true,
					}}
				/>
			)}

			<ProductSummaryContainer
				displayAccommodationAddress={true}
				displayAccommodationNights={false}
			/>
		</div>
	);
};

HotelHeader.propTypes = {
	hotelName: PropTypes.node.isRequired,
	tripAdvisorData: PropTypes.object,
	holidayCheckData: PropTypes.object,
	status: PropTypes.oneOf([
		PRODUCT_PAGE_CODE_STATUS.LOADING,
		PRODUCT_PAGE_CODE_STATUS.SUCCESS,
		PRODUCT_PAGE_CODE_STATUS.TECHNICAL_FAILURE,
		PRODUCT_PAGE_CODE_STATUS.SESSION_EXPIRED,
	]),
};

export default memo(HotelHeader);
